module.exports = __webpack_public_path__ + "img/loIcnGo.f174859e.png";